import { Hourglass } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Wordmark } from "@/pages/Login";

export default function Pending() {
  const { user, logout, check } = useAuth();
  return (
    <div className="min-h-screen grid place-items-center p-6" data-testid="pending-approval-page">
      <div className="card-surface max-w-md w-full p-8 fade-in">
        <Wordmark />
        <div className="mt-8 h-10 w-10 rounded-full bg-amber-50 grid place-items-center"><Hourglass className="h-5 w-5 text-amber-600" /></div>
        <h2 className="font-display text-xl font-bold mt-4">Awaiting approval</h2>
        <p className="text-sm text-gray-500 mt-2">
          Hi {user?.name}, your account ({user?.email}) has been registered. An administrator needs to approve it before you can access leads.
        </p>
        <div className="flex gap-2 mt-6">
          <Button data-testid="pending-refresh-button" variant="outline" onClick={check}>Check again</Button>
          <Button data-testid="pending-logout-button" variant="ghost" onClick={logout}>Sign out</Button>
        </div>
      </div>
    </div>
  );
}
